export default __webpack_public_path__ + "static/media/stop_push.9866eed7.svg";